import React, { useState } from 'react';
import { FaMobileAlt, FaMoneyBillWave, FaTimes } from 'react-icons/fa';
import API from '../../pages/Api';
import { toast } from 'react-toastify';

const PaymentSelection = ({ totalAmount, onProceed, onClose, userInfo, selectedCourses = [], isEvent = false, eventId = null }) => {
  const [selectedMethod, setSelectedMethod] = useState('upi');

  // 💡 Event Cash Payment Logic
  const handleEventCashProceed = async () => {
    
      console.log("Checking Payload:", { eventId, userInfo });

      try {
          const payload = {
              
              eventid: eventId, 
              userid: userInfo?.userid || userInfo?.id || localStorage.getItem('userId'), 
              txn_amount: totalAmount,
              cust_id: userInfo?.emailid || userInfo?.email || localStorage.getItem('userEmail'),
              payment_status: 'PENDING', 
              payment_method: 'cash' ,
              order_id: `ORD-${Date.now()}`    
          };
          
          console.log("Final Payload to Backend:", payload);

          const res = await API.post('admin/save-event-payment/', payload);
          
          if (res.status === 200 || res.status === 201) {

              toast.success(
                  res.data.message ||
                  "Payment request submitted successfully. Waiting for admin approval."
              );

              setTimeout(() => {

                  onClose();

                  window.location.reload();

              }, 2500);

          }
      } catch (err) {
          console.error("API Error:", err.response?.data || err);
          toast.error("Event booking failed! Please check your connection.");
      }
  };

  
  const handleCashProceed = async () => {
    let finalUserId = null;
    let finalEmail = null;

    try {
      const userRawData = localStorage.getItem('user');
      if (userRawData) {
        const parsedUser = JSON.parse(userRawData);
        finalEmail = parsedUser.emailid || parsedUser.email;
        finalUserId = parsedUser.userid || parsedUser.user_id || parsedUser.id;
      }
    } catch (e) {
      console.error("Error parsing user data from localStorage", e);
    }

    if (!finalUserId) {
        finalUserId = localStorage.getItem('userid') || localStorage.getItem('user_id') || userInfo?.userid || userInfo?.id;
    }
    if (!finalEmail) {
        finalEmail = localStorage.getItem('userEmail') || localStorage.getItem('emailid') || userInfo?.email;
    }

    if (!finalEmail) {
        toast.error("Session Expired! Please logout and login again to activate your course.");
        return;
    }

    const payload = {
        userid: finalUserId ? parseInt(finalUserId) : null, 
        cust_id: finalEmail,
        courseId: selectedCourses.map(c => c.id),
        txn_amount: totalAmount
    };

    try {

        const res = await API.post(
            'saveCashPayment/',
            payload
        );

        console.log("Payment Response:", res.data);

        toast.success(
            res.data.message ||
            "Payment request submitted successfully. Waiting for admin approval."
        );

        setTimeout(() => {

            window.location.href =
                "/TGSH/user/dashboard";

        }, 2000);

     } catch (err) {

        console.error(
            "Cash payment API error:",
            err.response?.data
        );

        toast.error(
            err.response?.data?.message ||
            err.response?.data?.error ||
            "Server Error"
        );
     }
  };
  // 💡 Main Proceed Logic
  const handleMainProceed = () => {

      console.log("Selected Method:", selectedMethod);
      console.log("Is Event:", isEvent);

      if (selectedMethod === 'cash') {

          if (isEvent) {

              handleEventCashProceed();

          } else {

              handleCashProceed();

          }

      } else {

          if (typeof onProceed === 'function') {

              onProceed(selectedMethod);

          }

      }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[2000]">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden relative animate-in fade-in zoom-in duration-300">
        <button onClick={onClose} className="absolute right-4 top-4 text-white hover:text-gray-200 transition-colors z-10 p-1 rounded-full hover:bg-white/10 border-none cursor-pointer">
          <FaTimes size={20} />
        </button>

        <div className="bg-[#001f54] p-8 text-center text-white">
          <h2 className="text-2xl font-serif mb-2 tracking-wide">Select Payment Method</h2>
          <p className="text-blue-200 text-lg">Total to pay: <span className="font-bold text-white text-2xl">₹{totalAmount || '0.00'}</span></p>
        </div>

        <div className="p-6 space-y-4">
          <label className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all ${selectedMethod === 'upi' ? 'border-blue-600 bg-blue-50' : 'border-gray-100 hover:bg-gray-50'}`}>
            <input type="radio" name="pay" className="hidden" checked={selectedMethod === 'upi'} onChange={() => setSelectedMethod('upi')} />
            <div className="bg-purple-100 p-3 rounded-lg text-purple-600 mr-4"><FaMobileAlt size={22} /></div>
            <div className="flex-1">
              <p className="font-bold text-gray-800 text-sm">UPI (PhonePe, Google Pay)</p>
            </div>
          </label>

          <label className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all ${selectedMethod === 'cash' ? 'border-green-600 bg-green-50' : 'border-gray-100 hover:bg-gray-50'}`}>
            <input type="radio" name="pay" className="hidden" checked={selectedMethod === 'cash'} onChange={() => setSelectedMethod('cash')} />
            <div className="bg-green-100 p-3 rounded-lg text-green-600 mr-4"><FaMoneyBillWave size={22} /></div>
            <div className="flex-1">
              <p className="font-bold text-gray-800 text-sm">Cash Payment (Offline)</p>
            </div>
          </label>

          <div className="pt-4 space-y-4">
            <button onClick={handleMainProceed} className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold shadow-lg hover:bg-blue-700 uppercase tracking-wider text-sm border-none cursor-pointer">
              Confirm & Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSelection;